import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const savedY = sessionStorage.getItem("formScrollY")
    if (savedY) {
      sessionStorage.removeItem("formScrollY")
      const y = parseInt(savedY, 10)
      // Turbo scrolls to top after connect, so we need to restore after it finishes
      document.addEventListener("turbo:load", () => window.scrollTo(0, y), { once: true })
      // Fallback for non-Turbo navigations
      requestAnimationFrame(() => requestAnimationFrame(() => window.scrollTo(0, y)))
    }
  }

  submit() {
    sessionStorage.setItem("formScrollY", window.scrollY.toString())

    this.submitButtons = Array.from(this.element.querySelectorAll('button[type="submit"], input[type="submit"]'))
    this.submitButtons.forEach((btn) => {
      btn.setAttribute("data-submitting", "")
      btn.disabled = true
      const originalText = btn.dataset.originalText || (btn.tagName === "INPUT" ? btn.value : btn.textContent)
      btn.dataset.originalText = originalText
      if (btn.tagName === "INPUT") {
        btn.value = "Saving…"
      } else {
        btn.innerHTML = `<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>${originalText}`
      }
    })
  }

  complete(event) {
    if (event.detail.success) return

    this.submitButtons?.forEach((btn) => {
      btn.disabled = false
      btn.removeAttribute("data-submitting")
      if (btn.tagName === "INPUT") {
        btn.value = btn.dataset.originalText
      } else {
        btn.textContent = btn.dataset.originalText
      }
    })
  }
}
